import React from 'react';

const ErrorsManagement: React.FC = () => {
  return (
    <div className="errors-management">
      <h2>Error Logs</h2>
      <div className="placeholder-content">
        <p></p>
      </div>
    </div>
  );
};

export default ErrorsManagement; 